<template>
  <div class="privilidge-tip">
    <!-- 如果来自新系统且没有登录 -->
    <div class="tip-container" v-if="!isLogin && !hasPrivilidge">
      暂无权限查看文章详情，请
      <el-button 
        type="text"
        @click="login"
      >登录</el-button>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

export default {
  props: {
    hasPrivilidge: {
      type: Boolean,
      default: true
    },
    mountedParent: {
      type: Function,
      default () {
        return function () {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  watch: {
    isLogin (val) {
      if (val) {
        this.mountedParent()
      }
    },
    hasPrivilidge (val) {
      if (!this.isLogin && !val) {
        this.login()
      }
    }
  },
  methods: {
    ...mapMutations({
      login: 'LOGIN_SHOW'
    })
  }
}
</script>

<style lang="scss" scoped>
  .tip-container {
    position: absolute;
    width: 600px;
    z-index: 3;
    left: 50%;
    top: 194px;
    margin-left: -300px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    background: #FFF;

    .el-button {
       font-size: 18px;
       font-weight: bold;
    }
  }
</style>




// WEBPACK FOOTER //
// src/modules/common/privilidge-out.vue